import { render, staticRenderFns } from "./Unternehmen.vue?vue&type=template&id=f4a465ae&scoped=true&"
import script from "./Unternehmen.vue?vue&type=script&lang=ts&"
export * from "./Unternehmen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a465ae",
  null
  
)

export default component.exports